import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GenericValidationsService } from 'src/app/Service/generic-validations.service';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { CONSTANTS, ENDPOINTS } from 'src/Core/Constant';
import { environment } from 'src/environments/environment';
import { TranslationService } from 'src/app/Service/translation.service';

@Component({
  selector: 'app-accommodation-details',
  templateUrl: './accommodation-details.component.html',
  styleUrls: ['./accommodation-details.component.scss']
})
export class AccommodationDetailsComponent {

  @Output() formGroupChange = new EventEmitter<FormGroup>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();
  @Input() isPreviewMode: boolean = false; // Flag to determine behavior
  @Input() applicantData: any; // Accept data from parent component

  @Input() ApplicationTypeId :any

  accommodationForm!: FormGroup;
  submitted = false;
  isJsonShow = environment.isJsonShow;  // Set isJsonShow from the environment
  SaveMode = CONSTANTS.SAVE_MODE;
  isEditable: boolean = true; // Flag to track if the form is editable

  constructor(private activatedRoute: ActivatedRoute,private router : Router,private fb: FormBuilder,private toastr: ToastrService,private api : SevaProfileService, public genericValidations: GenericValidationsService, private translationService: TranslationService) {
  }

  ngOnInit(): void {
    if (!this.isPreviewMode) {
    this.initializeForm();
    this.getApplicantData();
  }
}


      
ngOnChanges(changes: SimpleChanges): void {
  if (changes['applicantData'] && this.applicantData) {

    this.initializeForm();
    this.accommodationForm.patchValue(this.applicantData);
    this.accommodationForm.disable();
  }
}


  
  getApplicantData(){

  var endpoint = '';
    if(this.ApplicationTypeId == CONSTANTS.ApplicationTypeId.VISITING_SEVA){
      endpoint = ENDPOINTS.VISITING_SEVA.GET_ACCOMMODATION_REQUEST;
    }
    if(this.ApplicationTypeId == CONSTANTS.ApplicationTypeId.PTH){
      endpoint = ENDPOINTS.PTH.GET_ACCOMMODATION_REQUEST;
    }

    this.api.apiCall(endpoint, 'GET').subscribe((response: any) => {
      if (response.Data && Object.keys(response.Data).length > 0) {
        this.genericValidations.setProgressPercentage(response.Data.CompletionPercentage); // Example: Set progress to 50%
        
        // Store IsEditable flag from response
        this.isEditable = response.Data.IsEditable !== false; // Default to true if not provided

        // Disable form if not editable
        if (!this.isEditable) {
          this.accommodationForm.disable();
        } else {
          this.accommodationForm.enable();
        }
        
        this.accommodationForm.patchValue(response.Data);
      }
    })
  }



  initializeForm(){

   
    


  //  this.router.navigate(['/applicant/profile-summary'])

    this.accommodationForm = this.fb.group({
 
      ApplicationTypeId:[this.ApplicationTypeId,],  //vs
      HousingPreference: ['', Validators.required],
      HasSnoreHabit: [null, Validators.required],
      HasConcernsWithRoommates: [null, Validators.required],
      DescribeConcerns: [''],
      OtherAccommodationRequests: [''],
    
      SaveMode: ['', Validators.required]
    });

    this.formGroupChange.emit(this.accommodationForm);
  }




  
onSubmit(Mode: number): void {

  this.accommodationForm.patchValue({
    SaveMode: Mode
  })
  
  
  if (!this.accommodationForm.valid && Mode ==  this.SaveMode.SAVE) {
    this.submitted = true;
    this.accommodationForm.markAllAsTouched();
    this.toastr.warning('Please complete all required fields before submitting.');
    return
  }
  
  

  
  const cleanedValues = this.genericValidations.removeWhitespaceFromValues(this.accommodationForm.value);
  this.addUpdate(cleanedValues, Mode);
  
  
  
  
  }
  
  
  addUpdate(reqBoby: any, Mode: number) {


    let endpoint = '';
    if(this.ApplicationTypeId == CONSTANTS.ApplicationTypeId.VISITING_SEVA){
      endpoint = ENDPOINTS.VISITING_SEVA.SAVE_ACCOMMODATION_REQUEST;
    }
    if(this.ApplicationTypeId == CONSTANTS.ApplicationTypeId.PTH){
      endpoint = ENDPOINTS.PTH.SAVE_ACCOMMODATION_REQUEST;
    }


    this.api.apiCall(endpoint, 'POST', reqBoby).subscribe((response: any) => {
      this.toastr.success( response?.Message);
      if (Mode ==  this.SaveMode.SAVE) {
        this.nextStep.emit();
      }else if(Mode ==  this.SaveMode.DRAFT){
         this.getApplicantData();
      }
    });
  }
  
  

  goToBack() {
    this.previous.emit();
  }

  // Translations
  getTranslation(key: string): string {
    return this.translationService.getTranslation(key);
  }
}